/* eslint-disable no-unused-vars */
type StorageInfo = { [key: string]: string };

export const enum StorageKeys {
  CURRENT_STEP_INDEX = "current_step_index",
  STATEMENT_DATA = "statement_data",
  INVOICE_DETAILS = "invoice_details",
  INVOICE_REFERENCE = "invoice_reference",
  CUSTOMER_CONTACT = "customer_contact",
}
const ikStatement = "ikStatement";

const checkIfStorageAvailable = (): boolean => {
  if (typeof window !== "undefined" && typeof Storage !== "undefined") {
    return true;
  }
  return false;
};

const getSessionStorageData = (ikStatement: string): StorageInfo | null => {
  if (!checkIfStorageAvailable()) return null;

  const stringOrNull = sessionStorage.getItem(ikStatement);

  return stringOrNull ? JSON.parse(stringOrNull) : null;
};

const setSessionStorageData = (property: StorageKeys, value: string): boolean => {
  if (!checkIfStorageAvailable()) return false;

  const existingData = getSessionStorageData(ikStatement);

  if (!existingData) {
    const newData: StorageInfo = { [property]: value };
    sessionStorage.setItem(ikStatement, JSON.stringify(newData));
  } else {
    existingData[property] = value;
    sessionStorage.setItem(ikStatement, JSON.stringify(existingData));
  }

  return true;
};

const getFromSessionStorage = (property: StorageKeys): string | null => {
  const existingData = getSessionStorageData(ikStatement);

  if (!existingData) return null;

  return existingData[property];
};

const clearSessionStorage = (): void => {
  sessionStorage.removeItem(ikStatement);
};

export { getFromSessionStorage, setSessionStorageData, clearSessionStorage };
